<template>
	<div class="adsAccountManagement">
		<el-row type="flex" class="row-bg targetCustomerMatching-heard" justify="space-between">
			<filter-panel class="filter-panel" :data="swarchGroups" @search="filterChange" :simple="true">
			</filter-panel>
		</el-row>
		<el-col :span="24" class="google-list">
			<data-list
				style="margin-top: 10px"
				:page="page"
				:table-style="{ name: 'mixture' }"
				:data="data"
				:columns="columns"
				:loading="loading"
				@page-size-changed="pageSizeChanged"
				@page-changed="pageChanged"
				@sort-change="sortChange"
			></data-list>
		</el-col>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import customer from '@/mixins/customer';
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue';
import listPageCreate from '@/mixins/listPageCreate';
import api from '@/backend/apiConfig/apiConfig';
import blockList from '@/backend/pages/googleAds/components/blockList.vue';
import googleads from '@/backend/services/googleAds/googleAds.js';

const page = listPageCreate({
	searchConfig: {
		api: api.googleAds.detectionAccountList,
		method: 'POST',
	},
	// getQuery (obj, _this) {
	//   obj.sortField = obj.sortName;
	//   delete obj.sortName;
	//   delete obj.customerId;
	//   return _.assign(obj);
	// }
});
export default {
	name: 'adsAccountManagement',
	components: {
		blockList,
		filterPanel,
	},
	computed: {
		...mapGetters(['userInfo']),
	},
	mixins: [customer, page],
	data() {
		let _this = this;
		return {
			contentList: {},
			cidNumber: '',
			columns: [
				{
					label: '客户名称',
					bind: 'custName',
					align: 'left',
					type: 'percentage',
					style: {
						textAlign: 'left',
					},
					dataStyle(val) {
						return val || '-';
					},
				},
				{
					label: '有效服务单',
					bind: 'serviceCode',
					align: 'left',
					type: 'percentage',
					style: {
						textAlign: 'left',
					},
					dataStyle(val) {
						return val || '-';
					},
				},
				{
					label: '优化师',
					bind: 'staffName',
					align: 'left',
					type: 'percentage',
					style: {
						textAlign: 'left',
					},
					dataStyle(val) {
						return val || '-';
					},
				},
				{
					label: 'CID',
					bind: 'cid',
					align: 'left',
					type: 'percentage',
					style: {
						textAlign: 'left',
					},
					dataStyle(val) {
						return val || '-';
					},
				},
				{
					label: '主域名',
					bind: 'domains',
					align: 'left',
					type: 'percentage',
					style: {
						textAlign: 'left',
					},
					dataStyle(val) {
						return val || '-';
					},
				},
				{
					label: 'AI优化',
					type: 'switchBtn',
					bind: 'aiOptimizeEnabled',
					activeValue: true,
					inactiveValue: false,
					toggle(val, row) {
						_this.switchBtnChange(val, row);
					},
				},
				{
					label: '状态',
					bind: row => {
						let { detectionEnabled } = row;
						return detectionEnabled ? '已开启' : '未开启';
					},
					width: 150,
					getClass(row) {
						let { detectionEnabled } = row;
						return detectionEnabled ? 'normalText' : 'warning';
					},
				},
				{
					label: '操作',
					type: 'btnClick',
					align: 'left',
					style: 'text',
					width: 200,
					bind() {
						return [
							{
								text: '账户检测',
								trigger(row) {
									let { serviceId } = row;
									_this.$router.push({
										name: 'accountDetection',
										query: {
											serviceId,
										},
									});
								},
								showButton() {
									return _this.showButton('accountDetection');
								},
							},
							{
								text: '查看详情',
								trigger(row) {
									sessionStorage.setItem('serviceSiteId', row.serviceId); // googleAds接口需服务id
									sessionStorage.setItem('projectId', row.projectId); // 产品列表及产品详情需项目id
									_this.$router.push({
										name: 'accountManagement',
										query: {
											industryId: row.industryId,
										},
									});
								},
								showButton() {
									return _this.showButton('googleAdsDetail');
								},
							},
						];
					},
				},
			],
			swarchGroups: {
				others: [
					{
						label: '查询服务单',
						tagName: 'sky-input',
						placeholder: '查询服务单',
						prop: 'serviceCode',
						value: '',
					},
					{
						label: '查询服CID',
						tagName: 'sky-input',
						placeholder: '查询服CID',
						prop: 'cid',
						value: '',
					},
					{
						label: '查询优化师',
						tagName: 'sky-input',
						placeholder: '查询优化师',
						prop: 'serviceStaffName',
						value: '',
					},
					{
						tagName: 'sky-select',
						placeholder: 'AI优化状态',
						prop: 'aiOptimizeEnabled',
						value: '',
						options: [
							{
								label: '开启',
								value: true,
							},
							{
								label: '关闭',
								value: false,
							},
						],
					},
				],
			},
		};
	},
	methods: {
		requestData() {
			this.query();
		},
		showButton(pamis) {
			return this.getPermission(this.$permissionData[pamis].englishName);
		},
		// AI优化开关
		async switchBtnChange(val, row) {
			let { serviceId } = row;
			let params = {
				serviceId,
				enabled: val,
			};
			try {
				await googleads.aiOptimizeSwitch(params);
				this.$message({
					message: '操作成功',
					type: 'success',
				});
			} catch (error) {
				this.$message({
					message: error.message || '操作失败',
					type: 'error',
				});
				this.query();
			}
		},
	},
	mounted() {
		this.requestData();
	},
};
</script>

<style scoped lang="scss">
.textStyle {
	text-align: center;
	height: 40px;
	line-height: 40px;
}
</style>
